import { StateProvider, StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../../../../../application/UserProfile";
import { AuthorizedUiElementServiceProvider } from "../../../../../../../ui/authorizedUiElement/authorizedUiElementServiceProvider";
import { AuthorizedUiElementConfig } from "../../../../../../../ui/authorizedUiElement/authorizedUiElementConfig";

export const vsServiceName = "contractDetailTabsService";
export const vsProviderName = `${vsServiceName}Provider`;

export class ContractDetailTabsProvider extends AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig> {
  static $inject = ["$stateProvider"];

  constructor($stateProvider: StateProvider) {
    super($stateProvider);
  }

  override basePath: string = "main.contract.info";

  override $get: any = [
    "userProfile",
    "$state",
    (userProfile: UserProfile, $state: StateService) => {
      return this.defaultServiceFactory(userProfile, $state);
    },
  ];
}
